module.exports = __webpack_public_path__ + "img/logo.c319b77f.png";